// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2pLoV","consentsList":"PatientConsents_consentsList__2ic_y","consentsListEmpty":"PatientConsents_consentsListEmpty__hapaw"};